import { format } from 'date-fns';
import AddNoteModal from './modals/AddNoteModal';

const NotesPanel = () => {
  return (
    <>
      <div className='flex place-content-between'>
        <h2 className='text-[22px]/[28px] font-bold text-[#131212]'>
          Notes (2)
        </h2>

        <AddNoteModal />
      </div>

      <div>
        <div className='mt-[15px] flex place-content-between'>
          <div className='text-[12px]/[16px]'>
            {format(new Date(), 'MM/dd/yy')}
          </div>
          <div className='text-[12px]/[16px] font-bold'>Author</div>
        </div>
        <div className='bg-[#F4F4F5] p-[10px] text-[14px]/[20px]'>
          Eget ipsum risus egestas ut quis.
        </div>
        <div className='text-end text-[12px]/[16px] text-[#949599]'>
          Tag Tag
        </div>
      </div>
      <div>
        <div className='mt-[15px] flex place-content-between'>
          <div className='text-[12px]/[16px]'>
            {format(new Date(), 'MM/dd/yy')}
          </div>
          <div className='text-[12px]/[16px] font-bold'>Author</div>
        </div>
        <div className='bg-[#F4F4F5] p-[10px] text-[14px]/[20px]'>
          Mauris nulla laoreet vivamus mi dolor leo ac. Quam in est feugiat
          congue.
        </div>
        <div className='text-end text-[12px]/[16px] text-[#949599]'>
          Tag Tag Tag
        </div>
      </div>
    </>
  );
};

export default NotesPanel;
